import { render, staticRenderFns } from "./OrdersTransactionTab.vue?vue&type=template&id=22f495ac&scoped=true"
import script from "./OrdersTransactionTab.vue?vue&type=script&lang=ts"
export * from "./OrdersTransactionTab.vue?vue&type=script&lang=ts"
import style0 from "./OrdersTransactionTab.vue?vue&type=style&index=0&id=22f495ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f495ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f495ac')) {
      api.createRecord('22f495ac', component.options)
    } else {
      api.reload('22f495ac', component.options)
    }
    module.hot.accept("./OrdersTransactionTab.vue?vue&type=template&id=22f495ac&scoped=true", function () {
      api.rerender('22f495ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrdersTransactionTab.vue"
export default component.exports